import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { RootState } from 'stores'
import { Axis } from 'types/Axis'
import { updateAnswer } from './actions'
import { IHandlerProps, ISelectionProps, Question } from './component'

export interface IContainerProps {
  questionIndex: number
}

const getSingleAnswer = (state: RootState, props: IContainerProps) => {
  if (state.answers[props.questionIndex]) {
    return state.answers[props.questionIndex].answer
  }
}

const mapStateToProps = (
  state: RootState,
  props: IContainerProps
): ISelectionProps => ({
  selection: getSingleAnswer(state, props)
})

const mapDispatchToProps = (dispatch: Dispatch): IHandlerProps => ({
  handleAnswer: (questionIndex: number, answer: number, axis: Axis) => {
    dispatch(updateAnswer(questionIndex, answer, axis))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Question)
